import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const InputDateWrapper = styled("div")(({ theme }) => ({
  marginTop: "15px",
  marginBottom: "15px",
}));
const InputDateButton = styled(Button)(({ theme }) => ({
  background: "#FFFFFF",
  padding: "5px",
  minWidth: "fit-content",
  fontStyle: "normal",

  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "22px",
  color: "rgba(11, 11, 11, 0.5)",
  textTransform: "capitalize",
  fontFamily: theme.typography.fontFamily,
  height: "54px",
  width: "100%",
  border: "2px solid #E8E8E8",
  borderRadius: "10px",
  justifyContent: "start",
  paddingLeft: "15px",
  "&:hover": {
    background: "#FFFFFF",
  },
}));
export { InputDateButton, InputDateWrapper };
